import type { ComponentPublicInstance } from 'vue'

import type { Config, PlayLike } from '../@types/editor'

import {
  NUMBER_LOTTERY_CARD_HEADLINE_OFFSET,
  NUMBER_LOTTERY_SCROLL_TOLERANCE,
} from '../constants/numberLottery'
import { getScrollTopBelowHeader } from '../utils/stickyHeader'

export const useNumberLotteryFieldScroll = (
  fieldRefs: MaybeRefOrGetter<Maybe<HTMLElement[]>>,
  cardRef?: MaybeRefOrGetter<Maybe<ComponentPublicInstance>>,
) => {
  const { scrollTop } = useScrollUtils()

  const getCardTopBelowHeader = () => {
    const element = toValue(cardRef)?.$el
    return element instanceof HTMLElement ? getScrollTopBelowHeader(element) : 0
  }

  const scrollToNextIncompleteField = (config: Config, play: PlayLike) => {
    const nextIncompleteFieldIndex = play.fields.findIndex(
      ({ selected }, index) => selected.length < (config.numbers[index]?.selectableMax ?? 0),
    )
    if (nextIncompleteFieldIndex < 0) return

    const nextFieldRef = toValue(fieldRefs)?.[nextIncompleteFieldIndex]
    if (!nextFieldRef) return

    const fieldTop = getScrollTopBelowHeader(nextFieldRef) - NUMBER_LOTTERY_CARD_HEADLINE_OFFSET

    const top = Math.max(0, fieldTop, getCardTopBelowHeader())
    if (Math.abs(top - window.scrollY) <= NUMBER_LOTTERY_SCROLL_TOLERANCE) return

    scrollTop(top)
  }

  return { scrollToNextIncompleteField }
}
